module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjEzIiB2aWV3Qm94PSIwIDAgNiAxMyI+CiAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik02IDQuMjFIMy45NTdWMi44NmMwLS41MDYuMzMzLS42MjUuNTY4LS42MjVoMS40NDJWLjAwOEwzLjk4MSAwQzEuNzc3IDAgMS4yNzUgMS42NjEgMS4yNzUgMi43MjV2MS40ODRIMHYyLjI5NmgxLjI3NVYxM2gyLjY4MlY2LjUwNWgxLjgxTDYgNC4yMDl6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-facebook.svg
// module id = RT01
// module chunks = 13